import { getDatasWithOption } from '../../utils/service';
import { isDefined, isNotDefined, isObject, parseInt10, truthy, getFirstObjectHasProperty } from '../../utils/util';
import { getLoadingBarTpl } from '../../model/tpl/loadingbar';
import { BOARD } from '../../model/msg/board';
import moment from 'moment';

class Siege {
  constructor(options) {
    const _ = this;
    if (!options) return;

    _.CLASS_OCCUPIED_BY_RED_KNIGHT = 'siege__castle-redknights';

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      serverId: 1,
      integrationServerIds : [],
      global: window,
      data: null
    }, options);

    _.global = _.option.global;

    _.wrap = _.option.wrap;

    // server renewal
    _.tpl = {
      introduceSiegeFirstDay: function (serverName) {
        return `<div class="nodata"><p><strong>${serverName}</strong> 서버의 첫 공성은 <br>	2018. 10. 28. (일) 입니다.</p></div>`;
      }
    };
  }

  init() {
    const _ = this;

    if (! _.option.data.visible) {
      $('.wrap-section-siege').remove();
    }

    if (isDefined(_.wrap) || _.wrap.length) {
      const castles = $('.siege__map > span', _.wrap);
      castles.removeClass(_.CLASS_OCCUPIED_BY_RED_KNIGHT); // not occupied by npc (red knights)
      _.setInstance();
    }
    return _;
  }
  setInstance() {
    const _ = this;
    // console.log('# siege.js setInstance() ', _.wrap, _.option.data );
    let tmpl_item = _.option.data.items.map( (item, i) => {
    return `
      <div class="siege__article">
      <a href="${item.url}"><dl><dd class="thumb"><img src="${item.thumbnail}" class="thumb"></dd><dt><strong>${item.title}</strong><span class="server">${item.server}</span></dt><dd class="desc">${item.desc}</dd></dl></a>
      </div>`;
    }).join('');

    let tmpl = `
      <div class="siege__bundle">
      ${tmpl_item}
      </div>
    `;
    $('.siege__content', _.wrap).append(tmpl);

    _.setSiegeDate();

    // _.setData(_.option.serverId);

    // get server renewal data
    // _.setRenewalFirstSiege(_.option.serverId);

    return _;
  }

  setSiegeDate() {
    const _ = this,
      dateWrap = $('.siege__subject > span', _.wrap);

    if (dateWrap.length) {
      const date = moment(dateWrap.attr('data-date')).day(0).format('YYYY. MM. DD.');
      dateWrap.text(date);
    }
  }

  setData(serverId) {
    const _ = this;

    _.setLoadingBar(true);

    if (_.option.integrationServerIds.indexOf(serverId) >= 0) {
      _.setRenewalFirstSiege(serverId);
    } else {
      getDatasWithOption([{
        type: 'GET',
        url: `${_.option.apiDomain}/api/world/castle/${serverId}/siege`,
        dataType: 'json'

      }], (data) => {
        _.setLoadingBar(false);

        if (!data || !Array.isArray(data.siegeCastleList) || data.siegeCastleList.length <= 0) {
          _.global.alert(BOARD.RETRY_LATER);
          return;
        }

        _.setSiegeCastle(data);

      }, (data) => {
        _.setLoadingBar(false);
      });
    } // if else

  }

  setSiegeCastle(data) {
    const _ = this;

    let castles = $('.siege__map > span', _.wrap),
      castle = null;

    data.siegeCastleList.forEach(function (value, index, array) {
      castle = castles.filter(function () {
        return parseInt10($(this).attr('data-castle-id')) === value.castleId;
      });

      if (truthy(value.npcOccupied)) {
        castle.addClass(_.CLASS_OCCUPIED_BY_RED_KNIGHT);

      } else {
        castle.removeClass(_.CLASS_OCCUPIED_BY_RED_KNIGHT);
      }

      $('> strong', castle).text(value.pledge);
    });
  }

  setLoadingBar(flag) {
    const _ = this;

    if (truthy(flag)) {
      $('.siege__map', _.wrap).append(getLoadingBarTpl());

    } else {
      $('.loadingbar', _.wrap).remove();
    }
  }

  changeSiegeResult(serverId) {
    const _ = this;

    _.setData(serverId);

    _.setRenewalFirstSiege(serverId);
  }

  setRenewalFirstSiege(serverId) {
    const _ = this;

    if (isNotDefined(_.global._serverNameMap)) return;

    $('.nodata', _.wrap).remove();

    // const integrationServerIds = [60];
    if (_.option.integrationServerIds.indexOf(serverId) >= 0) {
      _.setLoadingBar(false);

      const obj = getFirstObjectHasProperty(_.global._serverNameMap, 'serverId', serverId);
      $('.siege__map', _.wrap).append(_.tpl.introduceSiegeFirstDay(obj.serverName));
    }
  }
}

export default Siege;


// WEBPACK FOOTER //
// ./_src/js/main/siege/Siege.js